import { memo } from "react";
import classNames from "classnames";
import { AccountCardProps } from "@components/financialAccount/AccountCard/AccountCard";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import "@components/financialAccount/AccountCard/AccountCard.scss";

export const KickAccountCard = memo(
    ({ iconSize = "xs" }: { iconSize?: AccountCardProps["iconSize"] }) => (
        <div className="account-card">
            <InstitutionIcon
                institution="kick"
                size={iconSize}
                className={classNames(
                    "account-card__icon",
                    `account-card__icon--${iconSize}`,
                )}
            />
            <div className="account-card__name-type">
                <div className="account-card__name">Kick</div>
            </div>
        </div>
    ),
);
KickAccountCard.displayName = "KickAccountCard";
